var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.286,
    height: 14.286,
    viewBox: "0 0 14.286 14.286",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "account_circle_FILL0_wght400_GRAD0_opsz48_1_",
    "data-name": "account_circle_FILL0_wght400_GRAD0_opsz48 (1)",
    d: "M6.536,15.161a10.284,10.284,0,0,1,2.232-1.205,6.645,6.645,0,0,1,2.375-.42,6.718,6.718,0,0,1,2.384.42,10.2,10.2,0,0,1,2.241,1.205,6.269,6.269,0,0,0,1.116-1.946,6.454,6.454,0,0,0,.33-2.071,5.949,5.949,0,0,0-6.071-6.071,5.949,5.949,0,0,0-6.071,6.071,6.3,6.3,0,0,0,.339,2.071A6.426,6.426,0,0,0,6.536,15.161Zm4.607-3.482A2.409,2.409,0,0,1,8.7,9.232a2.409,2.409,0,0,1,2.446-2.446,2.409,2.409,0,0,1,2.446,2.446,2.409,2.409,0,0,1-2.446,2.446Zm0,6.607a6.911,6.911,0,0,1-2.768-.562,7.2,7.2,0,0,1-3.812-3.813,7.113,7.113,0,0,1,0-5.545,7.221,7.221,0,0,1,3.812-3.8,7.113,7.113,0,0,1,5.545,0,7.245,7.245,0,0,1,3.8,3.8,7.113,7.113,0,0,1,0,5.545,7.221,7.221,0,0,1-3.8,3.813A6.892,6.892,0,0,1,11.143,18.286Zm0-1.071a6.549,6.549,0,0,0,1.92-.286,5.7,5.7,0,0,0,1.848-1,7.772,7.772,0,0,0-1.857-.982,5.55,5.55,0,0,0-3.821,0,7.772,7.772,0,0,0-1.857.982,5.7,5.7,0,0,0,1.848,1A6.549,6.549,0,0,0,11.143,17.214Zm0-6.607a1.316,1.316,0,1,0-.991-.384A1.341,1.341,0,0,0,11.143,10.607Zm0-1.375Zm0,6.679Z",
    transform: "translate(-4 -4)",
    fill: "#1f272e"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.7fe75539b9656f3174e21ba7e2926e86.svg";
export { ForwardRef as ReactComponent };